import { createContext } from "react";

export const Settings = createContext(null);
export const Task = createContext(null);
export const Views = createContext(null);
export const Patient = createContext(null);
